import PubSub from "underpub-js";
import gsap from 'gsap';

var ListingUnitsDirectory = function (options) {

  this.options = {
    $el: false,
    baseClass: 'mol-ListingUnitsDirectory',
  };

  $.extend(true, this.options, options);

};

ListingUnitsDirectory.prototype.init = function () {

  var self = this;

  self.isActive = self.options.$el.data("active") || false;

  PubSub.subscribe("loaded", () => {
    if (self.isActive) {
      gsap.to(window, {
        scrollTo: {
          y: self.options.$el[0],
        },
        duration: .8,
        delay: .3,
        ease: 'expo.inout',
      })
    }
  })

};

export default ListingUnitsDirectory;